import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const NONE = "__none__";

export default function UserSelect({ value, onChange, users, testid, placeholder = "Unassigned" }) {
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
      <SelectTrigger data-testid={testid} className="rounded-xl h-11">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>{placeholder}</SelectItem>
        {users.map((u) => (
          <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
